export default "__VITE_PUBLIC_ASSET__a6747f4a__"